module.exports = __webpack_public_path__ + "static/media/received-active.f0c31a85.svg";


//////////////////
// WEBPACK FOOTER
// /src/assets/icons/received-active.svg
// module id = ./src/assets/icons/received-active.svg
// module chunks = 0